<app-admin-dashboard >
  <div class="card">
    <p-breadcrumb
      class="max-w-full breadcrumb-style"
      [model]="breadcrumbMenuItems"
      [home]="breadcrumbHome"/>

    <form [formGroup]="formGroup">
      <div class="header-card separator pt-0">
        <div class="container-title">
          <h1 class="text-xl font-medium text-800 m-0">
            {{'AdminExportOffer.Detail.OfferDetailTitle' | translate}}
          </h1>
        </div>
      </div>

      <div class="mx-2 mt-4">
        <div class="detail-card grid">
          <div class="col-12 border-divider sm:col section">
            <div class="row-info">
              <p class="label-info">{{'AdminExportOffer.Detail.OfferIdLabel' | translate}}</p>
              <p class="p-info">{{exportOffer?.id}}</p>
            </div>
            <div class="row-info">
              <p class="label-info">{{'AdminExportOffer.Detail.ExporterLabel' | translate}}</p>
              <p class="p-info">{{exportOffer?.exporter?.contactName}}</p>
            </div>
          </div>

          <div class="col-12 border-divider sm:col section">
            <div class="row-info">
              <p class="label-info">{{'AdminExportOffer.Detail.SpecieLabel' | translate}}</p>
              <p class="p-info font-italic">{{exportOffer?.variety?.species | speciesName}}</p>
            </div>
            <div class="row-info">
              <p class="label-info">{{'AdminExportOffer.Detail.VarietyLabel' | translate}}</p>
              <p class="p-info">{{exportOffer?.variety?.name}}</p>
            </div>
          </div>

          <div class="col-12 border-divider sm:col section">
            <div class="row-info">
              <p class="label-info">{{'AdminExportOffer.Detail.LoadDateLabel' | translate}}</p>
              <p class="p-info">{{exportOffer?.created | date: 'dd-MM-yyyy'}}</p>
            </div>
            <div class="row-info">
              <p class="label-info">{{'AdminExportOffer.Detail.PriceLabel' | translate}}</p>
              <p class="p-info">{{exportOffer?.listPrice}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="body-card">
        <div class="p-fluid formgrid grid">

          <div class="custom-col">
            <label for="species">
              {{'AdminExportOffer.Detail.SpecieLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <p-dropdown id="species"
              formControlName="speciesId"
              [options]="species"
              optionLabel="name"
              optionValue="id"
              [filter]="true"
              filterBy="name"
              [showClear]="true"
              placeholder="{{'AdminExportOffer.Detail.SpecieLabel' | translate}}"
              (onChange)="loadSpeciesParams()"
              class="custom-dropdown"/>
          </div>

          <div class="custom-col">
            <label for="variety">
              {{'AdminExportOffer.Detail.VarietyLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <p-dropdown id="variety"
              formControlName="varietyId"
              [options]="varieties"
              optionLabel="name"
              optionValue="id"
              [filter]="true"
              filterBy="name"
              [showClear]="true"
              placeholder="{{'AdminExportOffer.Detail.VarietyLabel' | translate}}"
              class="custom-dropdown"/>
          </div>

          <div class="custom-col">
            <label for="caseQuantityPerPallet">
              {{'AdminExportOffer.Detail.PalletsPerBoxLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <p-inputNumber
              inputId="caseQuantityPerPallet"
              formControlName="caseQuantityPerPallet"
              placeholder="{{'AdminExportOffer.Detail.PalletsPerBoxLabel' | translate}}"
              class="custom-input-number"/>
            <small *ngIf="submit && formGroup.controls['caseQuantityPerPallet'].invalid"
              class="p-error">{{getErrorMessage('caseQuantityPerPallet')}}</small>
          </div>

          <div class="custom-col">
            <label for="listPrice">
              {{'AdminExportOffer.Detail.UnitPriceBoxLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <p-inputNumber
              inputId="listPrice"
              formControlName="listPrice"
              mode="currency"
              currency="USD"
              locale="en-US"
              class="custom-input-number"/>
          </div>

          <div class="custom-col">
            <label for="incoterm">
              {{'AdminExportOffer.Detail.SellingModeLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <p-dropdown
              inputId="incoterm"
              formControlName="incoterm"
              [options]="incotermsOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="{{'AdminExportOffer.Detail.SellingModeLabel' | translate}}"
              class="custom-dropdown"/>
            <small *ngIf="formGroup.controls['incoterm'].invalid"
              class="p-error">{{getErrorMessage('incoterm')}}</small>
          </div>

          <div class="custom-col">
            <label for="palletQuantity">
              {{'AdminExportOffer.Detail.PalletsQuantityLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <p-inputNumber
              inputId="palletQuantity"
              formControlName="palletQuantity"
              placeholder="{{'AdminExportOffer.Detail.PalletsQuantityLabel' | translate}}"
              class="custom-input-number"/>
          </div>

          <div class="custom-col">
            <label for="fridgeStorage">
              {{'AdminExportOffer.Detail.ColdStorageLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <p-dropdown id="fridgeStorage"
              formControlName="fridgeStorageId"
              [options]="fridgeStorages"
              optionLabel="name"
              optionValue="id"
              [filter]="true"
              filterBy="name"
              [showClear]="true"
              (onChange)="onChangeColdStorage()"
              [autoDisplayFirst]="false"
              placeholder="{{'AdminExportOffer.Detail.ColdStorageSelectionLabel' | translate}}"
              class="custom-dropdown">
            </p-dropdown>
            <small *ngIf="submit && formGroup.controls['fridgeStorageId'].invalid"
              class="p-error">{{getErrorMessage('fridgeStorageId')}}</small>
          </div>
        </div>

        <h2 class="text-lg font-medium text-800 mb-0 mt-5">
          {{'AdminExportOffer.Detail.ProductDescriptionTitle' | translate}}
        </h2>
        <div class="p-fluid formgrid grid">
          <div class="custom-col">
            <label for="harvestDate">
              {{'AdminExportOffer.Detail.HarvestDateLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <p-calendar
              *ngIf="exportOffer?.harvestTypeId === 1"
              inputId="harvestDate"
              formControlName="harvestDate"
              appendTo="body"
              [showButtonBar]="true"
              [showIcon]="true"
              [showWeek]="true"
              [firstDayOfWeek]="1"
              [readonlyInput]="true"
              class="custom-input-calendar"/>

            <p-calendar
              *ngIf="exportOffer?.harvestTypeId === 2 || exportOffer?.harvestTypeId === 3"
              inputId="harvestDate"
              formControlName="harvestDate"
              appendTo="body"
              [showButtonBar]="true"
              [showIcon]="true"
              [showWeek]="true"
              [firstDayOfWeek]="1"
              [readonlyInput]="true"
              selectionMode="range"
              class="custom-input-calendar"/>
            <small *ngIf="submit && formGroup.controls['harvestDate'].invalid"
              class="p-error">{{getErrorMessage('harvestDate')}}</small>
          </div>

          <div class="custom-col">
            <label for="netKilos">
              {{'AdminExportOffer.Detail.NetKilosLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <input
              pInputText
              inputId="netKilos"
              formControlName="netKilos"
              placeholder="{{'AdminExportOffer.Detail.NetKilosLabel' | translate}}"
              class="custom-input"/>
            <small *ngIf="submit && formGroup.controls['netKilos'].invalid"
              class="p-error">{{getErrorMessage('netKilos')}}</small>
          </div>

          <div class="custom-col">
            <label for="grossKilos">
              {{'AdminExportOffer.Detail.GrossKilosLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <input
              pInputText
              inputId="grossKilos"
              formControlName="grossKilos"
              placeholder="{{'AdminExportOffer.Detail.GrossKilosLabel' | translate}}"
              class="custom-input"/>
            <small *ngIf="submit && formGroup.controls['grossKilos'].invalid"
              class="p-error">{{getErrorMessage('grossKilos')}}</small>
          </div>

          <div class="custom-col">
            <label for="boxType">
              {{'AdminExportOffer.Detail.BoxTypeLabel' | translate}}
              <span class="mandatory-field">*</span>
            </label>
            <p-dropdown
              inputId="boxType"
              formControlName="boxType"
              [options]="boxTypes"
              optionLabel="label"
              optionValue="value"
              placeholder="{{'AdminExportOffer.Detail.BoxTypeLabel' | translate}}"
              class="custom-dropdown"/>
            <small *ngIf="submit && formGroup.controls['boxType'].invalid"
              class="p-error">{{getErrorMessage('boxType')}}</small>
          </div>

          <div class="custom-col">
            <label for="color">
              {{'AdminExportOffer.Detail.ColorLabel' | translate}}
            </label>
            <p-dropdown
              id="color"
              formControlName="color"
              [options]="colors"
              optionLabel="label"
              optionValue="value"
              placeholder="{{'AdminExportOffer.Detail.ColorLabel' | translate}}"
              class="custom-dropdown"/>
          </div>

          <div class="custom-col">
            <label for="speciesSize">
              {{'AdminExportOffer.Detail.SpeciesSizeLabel' | translate}}
            </label>
            <p-dropdown
              id="speciesSize"
              formControlName="speciesSize"
              [options]="sizes"
              optionLabel="name"
              optionValue="name"
              placeholder="{{'AdminExportOffer.Detail.SpeciesSizeLabel' | translate}}"
              class="custom-dropdown"/>
          </div>

          <div class="custom-col">
            <label for="readyToLoadDate">
              {{'AdminExportOffer.Detail.ReadyToLoadDateLabel' | translate}}
            </label>
            <p-calendar
              inputId="readyToLoadDate"
              formControlName="readyToLoadDate"
              appendTo="body"
              [showButtonBar]="true"
              [showIcon]="true"
              [showWeek]="true"
              [firstDayOfWeek]="1"
              class="custom-input-calendar"/>
          </div>

          <div class="custom-col">
            <label for="shelfLife">
              {{'AdminExportOffer.Detail.DurationDaysLabel' | translate}}
            </label>
            <p-inputNumber
              inputId="shelfLife"
              formControlName="shelfLife"
              placeholder="{{'AdminExportOffer.Detail.DurationLabel' | translate}}"
              [min]="1"
              [max]="1000"
              class="custom-input-number"/>
          </div>

          <div class="custom-col">
            <label for="basePallets">
              {{'AdminExportOffer.Detail.BasePalletsLabel' | translate}}
            </label>
            <p-dropdown
              inputId="basePallets"
              formControlName="basePallets"
              [options]="basePallets"
              optionLabel="label"
              optionValue="value"
              placeholder="{{'AdminExportOffer.Detail.BasePalletsLabel' | translate}}"
              class="custom-dropdown"/>
          </div>

          <div class="custom-col">
            <label for="isQualityControl">
              {{'AdminExportOffer.Detail.HasControlQualityLabel' | translate}}
            </label>
            <p-dropdown
              id="isQualityControl"
              formControlName="isQualityControl"
              [options]="qualityControlOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="{{'AdminExportOffer.Detail.HasControlQualityLabel' | translate}}"
              class="custom-dropdown"/>
          </div>

          <div class="custom-col">
            <label for="qualityControlDate">
              {{'AdminExportOffer.Detail.QualityControlDateLabel' | translate}}
            </label>
            <p-calendar
              inputId="qualityControlDate"
              formControlName="qualityControlDate"
              appendTo="body"
              [showButtonBar]="true"
              [showIcon]="true"
              [showWeek]="true"
              [firstDayOfWeek]="1"
              class="custom-input-calendar"/>
          </div>

          <div class="custom-col">
            <label for="marks">
              {{'AdminExportOffer.Detail.HasMarksLabel' | translate}}
            </label>
            <p-dropdown
              id="marks"
              formControlName="marks"
              [options]="marksOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="{{'AdminExportOffer.Detail.HasMarksLabel' | translate}}"
              class="custom-dropdown"/>
          </div>
        </div>

        <h2 class="text-lg font-medium text-800 mb-0 mt-5">
          {{'AdminExportOffer.Detail.DestinationMarketsTitle' | translate}}
        </h2>
        <div class="p-fluid formgrid grid">
          <div class="custom-col">
            <label for="marketCountry1">
              {{'AdminExportOffer.Detail.MarketLabel' | translate}} 1
              <span class="mandatory-field">*</span>
            </label>
            <p-dropdown
              inputId="marketCountry1"
              formControlName="marketCountry1Id"
              [options]="countries"
              optionValue="id"
              optionLabel="name"
              placeholder="{{'AdminExportOffer.Detail.FirstMarketLabel' | translate}}"
              class="custom-dropdown"/>
            <small *ngIf="submit && formGroup.controls['marketCountry1Id'].invalid"
              class="p-error">{{getErrorMessage('marketCountry1Id')}}</small>
          </div>
          <div class="custom-col">
            <label for="marketCountry2">
              {{'AdminExportOffer.Detail.MarketLabel' | translate}} 2
            </label>
            <p-dropdown
              inputId="marketCountry2"
              formControlName="marketCountry2Id"
              [options]="countries"
              optionValue="id"
              optionLabel="name"
              placeholder="{{'AdminExportOffer.Detail.SecondMarketLabel' | translate}}"
              class="custom-dropdown"/>
          </div>
          <div class="custom-col">
            <label for="marketCountry3">
              {{'AdminExportOffer.Detail.MarketLabel' | translate}} 3
            </label>
            <p-dropdown
              inputId="marketCountry3"
              formControlName="marketCountry3Id"
              [options]="countries"
              optionValue="id"
              optionLabel="name"
              placeholder="{{'AdminExportOffer.Detail.ThirdMarketLabel' | translate}}"
              class="custom-dropdown"/>
          </div>
        </div>

        <h2 class="text-lg font-medium text-800 mb-0 mt-5">
          {{'AdminExportOffer.Detail.CertificationsTitle' | translate}}
        </h2>
        <div class="col-12 md:col-6 lg:col-6">
          <p-table
            [value]="certificateTypes"
            [(selection)]="selectedCertifications"
            dataKey="id"
            class="certification-table">
            <ng-template pTemplate="header">
              <tr>
                <th id="all-check" style="width: 2rem">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th id="all-label" class="text-left">{{'AdminExportOffer.Detail.AllLabel' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-certification>
              <tr>
                <td>
                  <p-tableCheckbox [value]="certification"></p-tableCheckbox>
                </td>
                <td>{{ certification.name }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <h2 class="text-lg font-medium text-800 mb-0 mt-5">
          {{'AdminExportOffer.Detail.ImagesTitle' | translate}}
        </h2>
        <p-table [value]="pictures" class="images-table">
          <ng-template pTemplate="caption">
            <div class="flex justify-content-start align-items-center">
              <p-fileUpload
                #imagesUploader
                mode="basic"
                chooseLabel="{{'AdminExportOffer.Detail.LoadButton' | translate}}"
                [fileLimit]="1"
                [auto]="true"
                accept=".jpg, .jpeg, .png"
                [maxFileSize]="3000000"
                (onSelect)="onSelectImage($event, imagesUploader)"
                [disabled]="pictures.length === 3"
                class="upload-button"/>
            </div>
          </ng-template>
          <ng-template pTemplate="body" let-picture let-rowIndex="rowIndex">
            <tr>
              <td style="width: 10rem" class="image-container">
                <img [src]="getImageUrl(picture)" class="image-style" alt=""/>
              </td>
              <td>
                <span class="image-label">{{getImageName(picture)}}</span>
              </td>
              <td>
                <div class="flex justify-content-end align-items-center gap-4">
                  <p-button
                    icon="pi pi-times"
                    (onClick)="onRemoveImage(rowIndex)"
                    class="custom-button"/>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div class="flex align-items-center justify-content-end mt-5">
          <p-button
            label="{{'AdminExportOffer.Detail.GoBackButton' | translate}}"
            (onClick)="goToExportOffersPage()"
            styleClass="p-button-outlined"
            class="custom-button"/>
          <p-button
            label="{{'AdminExportOffer.Detail.SaveButton' | translate}}"
            [loading]="loading"
            (onClick)="save()"
            [style]="{'margin-left': '20px'}"
            class="custom-button"/>
        </div>
      </div>
    </form>
  </div>
</app-admin-dashboard>



<p-dialog
  header="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ModalTitle' | translate}}"
  [(visible)]="loadFridgestorageDialogVisible"
  [style]="{width: '70%'}"
  [modal]="true"
  class="cold-storage-dialog"
  (onHide)="onCloseColdStorageDialog()"
>
  <app-form-cold-storage
    [isSaveColdStorage]="isSaveColdStorage"
    [isClosed]="loadFridgestorageDialogVisible"
    [exporterEmail]="exportOffer?.exporter?.contactEmail"
    (closeDialog)="onCloseColdStorageDialog($event)"
  />
  <ng-template pTemplate="footer">
    <p-button
      label="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.CloseButton' | translate}}"
      (onClick)="onCloseColdStorageDialog()"
      styleClass="p-button-outlined"
      class="custom-button"/>
    <p-button
      label="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.SaveButton' | translate}}"
      (onClick)="onSaveColdStorage()"
      [loading]="loading"
      class="custom-button"/>
  </ng-template>
</p-dialog>
